
  // Sticky bar
  const bar = document.getElementById('stickyBar');
  const buyEl = document.getElementById('buy');
  window.addEventListener('scroll', () => {
    bar.classList.toggle('show', buyEl.getBoundingClientRect().bottom < 0);
  });

  // FAQ
  document.querySelectorAll('.faq-row').forEach(row => {
    row.querySelector('.faq-q').addEventListener('click', () => {
      const open = row.classList.contains('open');
      document.querySelectorAll('.faq-row').forEach(r => r.classList.remove('open'));
      if (!open) row.classList.add('open');
    });
  });

  // Scroll animations
  const obs = new IntersectionObserver(entries => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) setTimeout(() => e.target.classList.add('in'), i * 90);
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(el => obs.observe(el));
